/* Consentmo cookie banner reveal.

   Previous behaviour: the banner was hidden on load and only revealed on the
   visitor's first keypress, click or scroll. Anyone who left without
   interacting was never asked for consent and stayed on the denied defaults.

   Two further defects in the previous version:
     1. It toggled visibility on the element itself, so if the banner had not
        rendered yet the hide rule stayed in force indefinitely.
     2. It called .style on the querySelector result with no null check. On any
        page with no banner (already-consented visitors, and every region where
        the banner does not show) that threw a TypeError on each event - and
        because the throw happened before removeEventListener, the listeners
        were never removed, so it threw again on every subsequent scroll.

   Current behaviour: reveal on first interaction OR after REVEAL_DELAY_MS,
   whichever comes first, by removing the hide rule itself. Set
   REVEAL_DELAY_MS to 0 to show the banner immediately. */
(function () {
  'use strict';

  var REVEAL_DELAY_MS = 0;
  var listenerTypes = ['keypress', 'click', 'scroll'];
  var revealTimer = null;

  var hideStylesheet = document.createElement('style');
  hideStylesheet.textContent = '.csm-cookie-consent { visibility: hidden; }';
  document.head.appendChild(hideStylesheet);

  function reveal() {
    if (hideStylesheet && hideStylesheet.parentNode) {
      hideStylesheet.parentNode.removeChild(hideStylesheet);
    }

    var bar = document.querySelector('.csm-cookie-consent');
    if (bar) {
      bar.style.visibility = 'visible';
    }

    listenerTypes.forEach(function (type) {
      window.removeEventListener(type, reveal, false);
    });

    if (revealTimer) {
      clearTimeout(revealTimer);
      revealTimer = null;
    }
  }

  listenerTypes.forEach(function (type) {
    window.addEventListener(type, reveal, false);
  });

  revealTimer = setTimeout(reveal, REVEAL_DELAY_MS);
})();